import { useEffect } from "react";
import { useLocation, withRouter } from "react-router-dom";

/* Component used with React Router to scroll user to the top of the window on route change */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default withRouter(ScrollToTop);
